// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 522 ? "component---src-templates-international-landing-page-tsx" : chunkId) + "-" + {"522":"2b235df6529ad0502771","676":"ce657d9296feb5823d52","943":"0f79d6f92541de567cba"}[chunkId] + ".js";
};